// extracted by mini-css-extract-plugin
export var wordContainer = "_n1-0";